module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Active-call-cdd0c68e2351545edb07247efef710d7.svg";